export const whatIsPathEdges = [
  {
    id: "147.96.108.21-153.137.234.244",
    source: "147.96.108.21",
    target: "153.137.234.244",
    type: "straight",
  },
  {
    id: "60.189.8.165-153.137.234.244",
    source: "153.137.234.244",
    target: "60.189.8.165",
    type: "straight",
  },
  {
    id: "153.137.234.244-154.3.202.173",
    source: "154.3.202.173",
    target: "153.137.234.244",
    type: "straight",
  },
  {
    id: "153.137.234.244-211.67.180.202",
    source: "211.67.180.202",
    target: "153.137.234.244",
    type: "straight",
  },
  {
    id: "152.13.188.174-211.67.180.202",
    source: "211.67.180.202",
    target: "152.13.188.174",
    type: "straight",
  },
  {
    id: "141.232.212.227-211.67.180.202",
    source: "211.67.180.202",
    target: "141.232.212.227",
    type: "straight",
  },
  {
    id: "141.232.212.227-147.96.108.21",
    source: "147.96.108.21",
    target: "141.232.212.227",
    type: "straight",
  },
  {
    id: "81.8.198.111-147.96.108.21",
    source: "147.96.108.21",
    target: "81.8.198.111",
    type: "straight",
  },
  {
    id: "36.91.134.142-81.8.198.111",
    source: "36.91.134.142",
    target: "81.8.198.111",
    type: "straight",
  },
  {
    id: "36.91.134.142-141.232.212.227",
    source: "36.91.134.142",
    target: "141.232.212.227",
    type: "straight",
  },
  {
    id: "36.91.134.142-111.175.133.151",
    source: "36.91.134.142",
    target: "111.175.133.151",
    type: "straight",
  },
  {
    id: "36.91.134.142-217.116.75.71",
    source: "36.91.134.142",
    target: "217.116.75.71",
    type: "straight",
  },
  {
    id: "236.4.122.206-111.175.133.151",
    source: "236.4.122.206",
    target: "111.175.133.151",
    type: "straight",
  },
  {
    id: "146.252.110.200-236.4.122.206",
    source: "236.4.122.206",
    target: "146.252.110.200",
    type: "straight",
  },
  {
    id: "217.116.75.71-111.175.133.151",
    source: "217.116.75.71",
    target: "111.175.133.151",
    type: "straight",
  },
  {
    id: "146.252.110.200-223.4.8.20",
    source: "223.4.8.20",
    target: "146.252.110.200",
    type: "straight",
  },
  {
    id: "223.4.8.20-236.4.122.206",
    source: "236.4.122.206",
    target: "223.4.8.20",
    type: "straight",
  },
  {
    id: "12.25.68.13-236.4.122.206",
    source: "236.4.122.206",
    target: "12.25.68.13",
    type: "straight",
  },
  {
    id: "12.25.68.13-223.4.8.20",
    source: "223.4.8.20",
    target: "12.25.68.13",
    type: "straight",
  },
  {
    id: "12.25.68.13-252.141.62.183",
    source: "252.141.62.183",
    target: "12.25.68.13",
    type: "straight",
  },
  {
    id: "141.232.212.227-252.141.62.183",
    source: "252.141.62.183",
    target: "141.232.212.227",
    type: "straight",
  },
  {
    id: "244.44.72.92-252.141.62.183",
    source: "244.44.72.92",
    target: "252.141.62.183",
    type: "straight",
  },
  {
    id: "43.84.67.114-244.44.72.92",
    source: "244.44.72.92",
    target: "43.84.67.114",
    type: "straight",
  },
  {
    id: "43.84.67.114-245.23.186.119",
    source: "245.23.186.119",
    target: "43.84.67.114",
    type: "straight",
  },
  {
    id: "43.84.67.114-206.110.156.51",
    source: "206.110.156.51",
    target: "43.84.67.114",
    type: "straight",
  },
  {
    id: "70.71.155.180-206.110.156.51",
    source: "206.110.156.51",
    target: "70.71.155.180",
    type: "straight",
  },
  {
    id: "70.71.155.180-127.230.6.154",
    source: "127.230.6.154",
    target: "70.71.155.180",
    type: "straight",
  },
  {
    id: "127.230.6.154-139.171.251.254",
    source: "127.230.6.154",
    target: "139.171.251.254",
    type: "straight",
  },
  {
    id: "70.157.149.183-194.112.46.82",
    source: "70.157.149.183",
    target: "194.112.46.82",
    type: "straight",
  },
  {
    id: "127.230.6.154-194.112.46.82",
    source: "127.230.6.154",
    target: "194.112.46.82",
    type: "straight",
  },
  {
    id: "223.4.8.20-245.23.186.119",
    source: "245.23.186.119",
    target: "223.4.8.20",
    type: "straight",
  },
  {
    id: "217.111.129.107-245.23.186.119",
    source: "245.23.186.119",
    target: "217.111.129.107",
    type: "straight",
  },
  {
    id: "217.111.129.107-223.4.8.20",
    source: "223.4.8.20",
    target: "217.111.129.107",
    type: "straight",
  },
  {
    id: "146.252.110.200-217.111.129.107",
    source: "146.252.110.200",
    target: "217.111.129.107",
    type: "straight",
  },
  {
    id: "90.202.79.101-217.111.129.107",
    source: "90.202.79.101",
    target: "217.111.129.107",
    type: "straight",
  },
  {
    id: "86.207.231.189-90.202.79.101",
    source: "90.202.79.101",
    target: "86.207.231.189",
    type: "straight",
  },
  {
    id: "86.207.231.189-195.13.133.245",
    source: "195.13.133.245",
    target: "86.207.231.189",
    type: "straight",
  },
  {
    id: "195.13.133.245-253.170.131.59",
    source: "195.13.133.245",
    target: "253.170.131.59",
    type: "straight",
  },
  {
    id: "148.249.83.146-253.170.131.59",
    source: "148.249.83.146",
    target: "253.170.131.59",
    type: "straight",
  },
  {
    id: "148.249.83.146-100.0.214.167",
    source: "148.249.83.146",
    target: "100.0.214.167",
    type: "straight",
  },
  {
    id: "100.0.214.167-132.61.8.225",
    source: "132.61.8.225",
    target: "100.0.214.167",
    type: "straight",
  },
  {
    id: "111.175.133.151-132.61.8.225",
    source: "132.61.8.225",
    target: "111.175.133.151",
    type: "straight",
  },
  {
    id: "70.184.56.117-148.249.83.146",
    source: "148.249.83.146",
    target: "70.184.56.117",
    type: "straight",
  },
  {
    id: "70.184.56.117-100.0.214.167",
    source: "100.0.214.167",
    target: "70.184.56.117",
    type: "straight",
  },
  {
    id: "62.136.182.25-70.184.56.117",
    source: "62.136.182.25",
    target: "70.184.56.117",
    type: "straight",
  },
  {
    id: "62.136.182.25-244.146.178.108",
    source: "62.136.182.25",
    target: "244.146.178.108",
    type: "straight",
  },
  {
    id: "219.238.233.252-244.146.178.108",
    source: "219.238.233.252",
    target: "244.146.178.108",
    type: "straight",
  },
  {
    id: "94.96.165.173-219.238.233.252",
    source: "219.238.233.252",
    target: "94.96.165.173",
    type: "straight",
  },
  {
    id: "80.103.55.164-244.146.178.108",
    source: "80.103.55.164",
    target: "244.146.178.108",
    type: "straight",
  },
  {
    id: "80.103.55.164-148.115.20.236",
    source: "80.103.55.164",
    target: "148.115.20.236",
    type: "straight",
  },
  {
    id: "80.103.55.164-255.172.212.254",
    source: "80.103.55.164",
    target: "255.172.212.254",
    type: "straight",
  },
  {
    id: "148.115.20.236-255.172.212.254",
    source: "148.115.20.236",
    target: "255.172.212.254",
    type: "straight",
  },
  {
    id: "217.116.75.71-255.172.212.254",
    source: "217.116.75.71",
    target: "255.172.212.254",
    type: "straight",
  },
  {
    id: "148.115.20.236-255.172.212.254",
    source: "148.115.20.236",
    target: "255.172.212.254",
    type: "straight",
  },
  {
    id: "94.96.165.173-255.172.212.254",
    source: "94.96.165.173",
    target: "255.172.212.254",
    type: "straight",
  },
  {
    id: "94.96.165.173-155.21.161.111",
    source: "94.96.165.173",
    target: "155.21.161.111",
    type: "straight",
  },
  {
    id: "60.189.8.165-155.21.161.111",
    source: "60.189.8.165",
    target: "155.21.161.111",
    type: "straight",
  },
  {
    id: "155.21.161.111-252.241.212.237",
    source: "252.241.212.237",
    target: "155.21.161.111",
    type: "straight",
  },
  {
    id: "152.13.188.174-244.44.72.92",
    source: "244.44.72.92",
    target: "152.13.188.174",
    type: "straight",
  },
  {
    id: "154.3.202.173-207.83.12.80",
    source: "154.3.202.173",
    target: "207.83.12.80",
    type: "straight",
  },
  {
    id: "207.83.12.80-252.241.212.237",
    source: "252.241.212.237",
    target: "207.83.12.80",
    type: "straight",
  },
  {
    id: "110.53.112.104-207.83.12.80",
    source: "110.53.112.104",
    target: "207.83.12.80",
    type: "straight",
  },
  {
    id: "110.53.112.104-226.93.229.239",
    source: "110.53.112.104",
    target: "226.93.229.239",
    type: "straight",
  },
  {
    id: "9.15.69.218-155.21.161.111",
    source: "9.15.69.218",
    target: "155.21.161.111",
    type: "straight",
  },
  {
    id: "9.15.69.218-207.83.12.80",
    source: "9.15.69.218",
    target: "207.83.12.80",
    type: "straight",
  },
  {
    id: "9.15.69.218-154.3.202.173",
    source: "9.15.69.218",
    target: "154.3.202.173",
    type: "straight",
  },
  {
    id: "197.238.77.25-226.93.229.239",
    source: "197.238.77.25",
    target: "226.93.229.239",
    type: "straight",
  },
  {
    id: "192.225.154.100-197.238.77.25",
    source: "197.238.77.25",
    target: "192.225.154.100",
    type: "straight",
  },
  {
    id: "197.238.77.25-226.93.229.239",
    source: "197.238.77.25",
    target: "226.93.229.239",
    type: "straight",
  },
  {
    id: "4.206.89.123-197.238.77.25",
    source: "197.238.77.25",
    target: "4.206.89.123",
    type: "straight",
  },
  {
    id: "4.206.89.123-119.42.164.123",
    source: "119.42.164.123",
    target: "4.206.89.123",
    type: "straight",
  },
  {
    id: "4.206.89.123-174.12.151.6",
    source: "174.12.151.6",
    target: "4.206.89.123",
    type: "straight",
  },
  {
    id: "119.42.164.123-174.12.151.6",
    source: "174.12.151.6",
    target: "119.42.164.123",
    type: "straight",
  },
  {
    id: "45.210.194.225-174.12.151.6",
    source: "174.12.151.6",
    target: "45.210.194.225",
    type: "straight",
  },
  {
    id: "4.206.89.123-45.210.194.225",
    source: "4.206.89.123",
    target: "45.210.194.225",
    type: "straight",
  },
  {
    id: "187.132.52.96-192.225.154.100",
    source: "187.132.52.96",
    target: "192.225.154.100",
    type: "straight",
  },
  {
    id: "187.132.52.96-203.101.73.159",
    source: "187.132.52.96",
    target: "203.101.73.159",
    type: "straight",
  },
  {
    id: "70.157.149.183-187.132.52.96",
    source: "187.132.52.96",
    target: "70.157.149.183",
    type: "straight",
  },
  {
    id: "85.125.75.64-203.101.73.159",
    source: "85.125.75.64",
    target: "203.101.73.159",
    type: "straight",
  },
  {
    id: "85.125.75.64-211.67.180.202",
    source: "85.125.75.64",
    target: "211.67.180.202",
    type: "straight",
  },
  {
    id: "85.125.75.64-154.3.202.173",
    source: "85.125.75.64",
    target: "154.3.202.173",
    type: "straight",
  },
  {
    id: "85.125.75.64-153.137.234.244",
    source: "85.125.75.64",
    target: "153.137.234.244",
    type: "straight",
  },
  {
    id: "45.210.194.225-255.44.167.4",
    source: "45.210.194.225",
    target: "255.44.167.4",
    type: "straight",
  },
  {
    id: "110.53.112.104-255.44.167.4",
    source: "110.53.112.104",
    target: "255.44.167.4",
    type: "straight",
  },
  {
    id: "50.241.244.156-245.23.186.119",
    source: "245.23.186.119",
    target: "50.241.244.156",
    type: "straight",
  },
  {
    id: "187.219.83.42-252.141.62.183",
    source: "187.219.83.42",
    target: "252.141.62.183",
    type: "straight",
  },
  {
    id: "31.172.218.103-244.44.72.92",
    source: "31.172.218.103",
    target: "244.44.72.92",
    type: "straight",
  },
  {
    id: "164.176.197.211-152.13.188.174",
    source: "164.176.197.211",
    target: "152.13.188.174",
    type: "straight",
  },
  {
    id: "152.209.153.144-206.110.156.51",
    source: "152.209.153.144",
    target: "206.110.156.51",
    type: "straight",
  },
  {
    id: "24.139.17.240-70.71.155.180",
    source: "24.139.17.240",
    target: "70.71.155.180",
    type: "straight",
  },
  {
    id: "18.24.34.114-203.101.73.159",
    source: "18.24.34.114",
    target: "203.101.73.159",
    type: "straight",
  },
  {
    id: "60.47.202.91-203.101.73.159",
    source: "60.47.202.91",
    target: "203.101.73.159",
    type: "straight",
  },
  {
    id: "171.164.198.139-197.238.77.25",
    source: "171.164.198.139",
    target: "197.238.77.25",
    type: "straight",
  },
  {
    id: "4.206.89.123-94.201.149.236",
    source: "4.206.89.123",
    target: "94.201.149.236",
    type: "straight",
  },
  {
    id: "165.17.12.227-174.12.151.6",
    source: "165.17.12.227",
    target: "174.12.151.6",
    type: "straight",
  },
  {
    id: "12.17.193.233-45.210.194.225",
    source: "12.17.193.233",
    target: "45.210.194.225",
    type: "straight",
  },
  {
    id: "197.234.165.5-255.44.167.4",
    source: "197.234.165.5",
    target: "255.44.167.4",
    type: "straight",
  },
  {
    id: "226.93.229.239-255.136.37.41",
    source: "226.93.229.239",
    target: "255.136.37.41",
    type: "straight",
  },
  {
    id: "110.53.112.104-238.88.35.10",
    source: "110.53.112.104",
    target: "238.88.35.10",
    type: "straight",
  },
  {
    id: "152.56.204.194-154.3.202.173",
    source: "152.56.204.194",
    target: "154.3.202.173",
    type: "straight",
  },
  {
    id: "1.233.70.18-9.15.69.218",
    source: "1.233.70.18",
    target: "9.15.69.218",
    type: "straight",
  },
  {
    id: "147.96.108.21-161.76.18.151",
    source: "147.96.108.21",
    target: "161.76.18.151",
    type: "straight",
  },
  {
    id: "147.96.108.21-214.98.126.104",
    source: "147.96.108.21",
    target: "214.98.126.104",
    type: "straight",
  },
  {
    id: "81.8.198.111-98.131.154.187",
    source: "81.8.198.111",
    target: "98.131.154.187",
    type: "straight",
  },
  {
    id: "72.2.16.86-155.21.161.111",
    source: "72.2.16.86",
    target: "155.21.161.111",
    type: "straight",
  },
  {
    id: "72.83.135.1-94.96.165.173",
    source: "72.83.135.1",
    target: "94.96.165.173",
    type: "straight",
  },
  {
    id: "147.1.12.217-148.115.20.236",
    source: "147.1.12.217",
    target: "148.115.20.236",
    type: "straight",
  },
  {
    id: "197.54.1.189-217.116.75.71",
    source: "197.54.1.189",
    target: "217.116.75.71",
    type: "straight",
  },
  {
    id: "21.253.248.33-236.4.122.206",
    source: "21.253.248.33",
    target: "236.4.122.206",
    type: "straight",
  },
  {
    id: "241.56.61.247-244.146.178.108",
    source: "241.56.61.247",
    target: "244.146.178.108",
    type: "straight",
  },
  {
    id: "150.113.117.10-253.170.131.59",
    source: "150.113.117.10",
    target: "253.170.131.59",
    type: "straight",
  },
  {
    id: "4.241.146.124-86.207.231.189",
    source: "4.241.146.124",
    target: "86.207.231.189",
    type: "straight",
  },
  {
    id: "9.61.107.6-217.111.129.107",
    source: "9.61.107.6",
    target: "217.111.129.107",
    type: "straight",
  },
  {
    id: "227.81.247.134-252.141.62.183",
    source: "227.81.247.134",
    target: "252.141.62.183",
    type: "straight",
  },
  {
    id: "9.160.41.252-111.175.133.151",
    source: "9.160.41.252",
    target: "111.175.133.151",
    type: "straight",
  },
  {
    id: "70.157.149.183-86.199.13.22",
    source: "70.157.149.183",
    target: "86.199.13.22",
    type: "straight",
  },
];
